<template>
    <div class="TimetableEditor">
		
		<card
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"	>
			<h3>Расписание работы колл-центра по дням недели</h3>
			<el-table :data="ApiDataWeekDays" style="width: 100%;">
				<el-table-column
					label="День недели"
					property="day"
					width="180"
				></el-table-column>

				<el-table-column
					label="Время начала"
					property="timeBegin"
					width="250"
				>
					<template v-slot="scope">
						<base-input
						v-model="scope.row.timeBegin"
						autocomplete="off"
						type="text"
						>
						</base-input>
					</template>
				</el-table-column>

				<el-table-column 
					width="250"
					label="Время окончания"
					property="timeEnd"
				>
					<template v-slot="scope">
						<base-input
						v-model="scope.row.timeEnd"
						autocomplete="off"
						type="text"
						>
						</base-input>
					</template>
			
				</el-table-column>
				<el-table-column
					label="Действие"
					align="right"
				>
					<template v-slot="scope">	
						<el-tooltip content="Сохранить изменения" placement="top">			
							<el-button class="no-border my-0">
								<button class="ml-3 btn btn-icon btn-simple btn-success" @click="UpdateTimeWeeks(scope.row)">
									<i class="tim-icons icon-book-bookmark"></i>
								</button>											
							</el-button>
						</el-tooltip>
					</template>
				</el-table-column>
			
			<!-- <el-table-column
					width="120"
					label="Действие"
					align="right"                    	
			>
				<template slot-scope="scope">		
					<ReActionBtns :masActions="masActions[scope.$index]"/>
					
				</template>
			</el-table-column>			 -->
			</el-table>
			
		</card>

		<card>
			<div class="">
				<h5><i class="tim-icons icon-send text-success mr-3"></i>Добавить изменения в расписании по конкртеным дням</h5>
			</div>
			
			<div>
				<ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Добавить" />
			</div>
		</card>
		<card>
			<h3>Изменения в расписании по конкртеным дням</h3>
			<el-table :data="ApiDataDays" style="width: 100%;">
				<el-table-column
					label="День"
					property="date"
					width="180"
				>
					<template v-slot="scope">
						{{ $GVO.convertDateFromMysql(scope.row.date) }}
					</template>
				
				</el-table-column>

				<el-table-column
					label="Время начала"
					property="timeBegin"
					width="250"
				>	
				<template v-slot="scope">
					<base-input
					v-model="scope.row.timeBegin"
					autocomplete="off"
					type="text"
					>
					</base-input>
				</template>
				</el-table-column>

				<el-table-column 
					width="250"
					label="Время окончания"
					property="timeEnd"
				>
				<template v-slot="scope">
					<base-input
					v-model="scope.row.timeEnd"
					autocomplete="off"
					type="text"
					>
					</base-input>
				</template>
				</el-table-column>

				<el-table-column
					
					label="Действие"
					align="right"
				>
					<template v-slot="scope">	
						<el-tooltip content="Сохранить изменения" placement="top">	
							<el-button class="no-border my-0" @click="UpdateTimeDay(scope.row)">
								<button class="ml-3 btn btn-icon btn-simple btn-success">
									<i class="tim-icons icon-book-bookmark"></i>
								</button>											
							</el-button>
						</el-tooltip>	
						<el-tooltip content="Удалить строчку" placement="top">
							<el-button class="no-border my-0" @click="DeleteRow(scope.row)">
								<button class="ml-3 btn btn-icon btn-simple btn-danger">
									<i class="tim-icons icon-trash-simple"></i>
								</button>											
							</el-button>
						</el-tooltip>	
					</template>
				</el-table-column>
			
			<!-- <el-table-column
					width="120"
					label="Действие"
					align="right"                    	
			>
				<template slot-scope="scope">		
					<ReActionBtns :masActions="masActions[scope.$index]"/>
					
				</template>
			</el-table-column>			 -->
			</el-table>
			<!-- <Pagination class="mt-3" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masObjects_total)*parseInt(count2page)" 
				:perPage="parseInt(count2page)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination> -->
		</card>
    </div>
</template>
<script>

// import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import { BaseSwitch } from 'src/components/index';
// import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
// import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
// import Pagination from 'src/our_components/RePagination';
// import ReActionBtns from 'src/our_components/ReActionBtns.vue';

export default {
	name: 'timetable_editor-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
		[Button.name]: Button,
		// BaseSwitch,
		// ReFilterBtn,
        // ReFilter,
        ReFormPrinter,
        // Pagination,
		// ReActionBtns,

	},
	data() {
		return {
			ApiDataWeekDays: [],
			ApiDataDays: [],
			masAllFormParams: this.currentFormConfig(),
			currentApiFormMethod: this.currentApiFormMethodComp(),
			objGetParams:{},
			masObjects_total: 0,
			// count2page: 10,
			// masActions:[],	
			// saveToServName:'',
			fullscreenLoading: false,
		};
	},
	methods: {
		getApiDataWeekDays(){
			this.$GVO.ApiCall('LEAD.GET_week_days',{flt:{}} )
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiDataWeekDays = objApi.data;

						// this.masActions = [];
						// for (let i = 0; i < this.ApiDataWeekDays.length; i++) {
						// 	this.masActions.push([
						// 		{
						// 			actionType: 'switcher',
						// 			label_on: 'Вкл',
						// 			label_off: 'Выкл',
						// 			action_model: this.ApiData[i].act=='1'?true:false,						
						// 			onClickApi: {apiMethod: 'CHANGE_ACT',apiParam:{obj:'PHONE_WHITELIST',flt:{id:this.ApiData[i].id}}},
						// 		},
						// 		// {
						// 		// 	actionType: 'btn_save',
								
						// 		// 	// action_model: this.ApiData[i].act=='1'?true:false,						
						// 		// 	onClickApi: {apiMethod: 'UPD',apiParam:{obj:'PHONE_WHITELIST',flt:{id:this.ApiData[i].id},name:this.ApiData[i].name},},
						// 		// },
						// 		// {
						// 		// 	actionType: 'btn_del',
						// 		// 	onClickApi: {apiMethod:'DEL',apiParam:{obj:'BP_CHECKLIST',flt:{id:this.ApiData[i].id}}},
						// 		// },
						// 	]);							
						// }
					}else{
						this.ApiDataWeekDays = [];
						
					}
				}else{
					this.ApiDataWeekDays = [];
					
				}
			}).catch(errorObjApi => {this.ApiDataWeekDays = []; console.error(errorObjApi);});
		},
		getApiDataDays(){
			this.$GVO.ApiCall('LEAD.GET_days',{flt:{}} )
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiDataDays = objApi.data;

						// this.masActions = [];
						// for (let i = 0; i < this.ApiDataWeekDays.length; i++) {
						// 	this.masActions.push([
						// 		{
						// 			actionType: 'switcher',
						// 			label_on: 'Вкл',
						// 			label_off: 'Выкл',
						// 			action_model: this.ApiData[i].act=='1'?true:false,						
						// 			onClickApi: {apiMethod: 'CHANGE_ACT',apiParam:{obj:'PHONE_WHITELIST',flt:{id:this.ApiData[i].id}}},
						// 		},
						// 		// {
						// 		// 	actionType: 'btn_save',
								
						// 		// 	// action_model: this.ApiData[i].act=='1'?true:false,						
						// 		// 	onClickApi: {apiMethod: 'UPD',apiParam:{obj:'PHONE_WHITELIST',flt:{id:this.ApiData[i].id},name:this.ApiData[i].name},},
						// 		// },
						// 		// {
						// 		// 	actionType: 'btn_del',
						// 		// 	onClickApi: {apiMethod:'DEL',apiParam:{obj:'BP_CHECKLIST',flt:{id:this.ApiData[i].id}}},
						// 		// },
						// 	]);							
						// }
					}else{
						this.ApiDataDays = [];
						
					}
				}else{
					this.ApiDataDays = [];
					
				}
			}).catch(errorObjApi => {this.ApiDataDays = []; console.error(errorObjApi);});
		},
		currentFormConfig() {
			this.$GVO.ApiCall('LEAD.GET_FORM_DAYS',{})
				.then((objApi) => {
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentApiFormMethodComp(){
            return {apiMethod:'LEAD.INS_days',apiParam:{iData:[]}};
        },
		SuccessGo(){
	        this.masAllFormParams = this.currentFormConfig();
			this.getApiDataWeekDays();
		},		
		UpdateTimeWeeks(row){
			if(row.day != null){
				this.$GVO.ApiCall('LEAD.UPD_week_days',{ flt:{day: row.day},uData:{
					'timeBegin': row.timeBegin, 
					'timeEnd': row.timeEnd,

					}}).then((objApi) => {
						//console.log(objApi);
						if(objApi.success === true){
							this.getApiDataWeekDays();
							this.openFullScreen1();
						}else{
							this.$GVO.showAlert('Редактирование',objApi.msg);
							// alert('Не сохранилось');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
			}

		},
		UpdateTimeDay(row){
			if(row.date != null){
				this.$GVO.ApiCall('LEAD.UPD_days',{ flt:{date: row.date},uData:{
					// 'date': row.date, 
					'timeBegin': row.timeBegin, 
					'timeEnd': row.timeEnd,

					}}).then((objApi) => {
						//console.log(objApi);
						if(objApi.success === true){
							this.getApiDataDays();
							this.openFullScreen1();
						}else{
							this.$GVO.showAlert('Редактирование',objApi.msg);
							// alert('Не сохранилось');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
			}

		},
		DeleteRow(row){
			if(row.date != null){
				this.$GVO.ApiCall('LEAD.DEL_days',{ flt:{date: row.date}}) 
					.then((objApi) => {
						if(objApi.success === true){
							this.getApiDataDays();
						}else{
							this.$GVO.showAlert('Редактирование',objApi.msg);
							// alert('Не удалилось');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
			}
		},
		// pClick(e){
		// 	this.objGetParams['p'] = parseInt(e);
		// 	// this.OnFilterApply();
		// },
		// UpdateList(row){
		// 	if(row.id != null){
		// 		this.$GVO.ApiCall('PHONE_WHITELIST.UPD',{ flt:{id: row.id},uData:{
		// 			'description': row.description, 
		// 			'act': row.act,
		// 			'phone': row.phone,
		// 			'fio': row.fio,
		// 			'agent_id': row.agent_id,
		// 			}}).then((objApi) => {
		// 				//console.log(objApi);
		// 				if(objApi.success === true){
		// 					this.getApiData();
		// 					this.openFullScreen1();
		// 				}else{
		// 					alert('Не сохранилось');
		// 				}
		// 			}).catch(errorObjApi => {console.log(errorObjApi);});
		// 	}
		// }, 
		// GoEdit(row){
		// 	if(row.id != null){
		// 		this.$router.push({path: this.$GVO.str_replace('/helpdesk','/helpdeskstaff',location.pathname)+'/'+row.id});
		// 	}
		// }
		openFullScreen1(){
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 10000);
		},
	},		
	mounted() {
		this.getApiDataWeekDays();
		this.getApiDataDays();
	}
};
</script>
<style>
.TimetableEditor .bntGroup {
	display: flex;
	justify-content: flex-start;
}
.TimetableEditor .form-options-group{
	flex-direction: row;
	width: 100%;
	align-items: center;
	flex-wrap: wrap;
}
.TimetableEditor .form-options-group > div{
	margin-right: 5px;
}
.TimetableEditor .form-group {
	margin-bottom: 0px!important;
}
.TimetableEditor-table .cell, .Cellraspred-table button {
	word-break: break-word!important;
}
.TimetableEditor .el-table tr:hover {
    background: rgb(1, 176, 224, 0.33);
}


</style>
